document.addEventListener('DOMContentLoaded', () => {
  // Seleciona todas as imagens que são o último filho dentro de .pmc .left_cont_img
  document.querySelectorAll('.pmc .left_cont_img img:last-child').forEach(img => {

    // Quando o rato passa por cima
    img.addEventListener('mouseenter', () => {
      const firstImg = img.parentElement.querySelector('img:first-child');
      if (firstImg) firstImg.style.opacity = '0.5';
    });

    // Quando o rato sai
    img.addEventListener('mouseleave', () => {
      const firstImg = img.parentElement.querySelector('img:first-child');
      if (firstImg) firstImg.style.opacity = '1';
    });

  });
});